var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ph-special-main"},[_c('el-backtop'),(_vm.showHeader)?_c('hpheader'):_vm._e(),_c('specialEndo'),_c('hpfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }